import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fn-grid-boolean',
    templateUrl: 'fn-grid-boolean.component.html',
    styleUrls: ['fn-grid-boolean.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FnGridBooleanComponent extends FnGridAbstractCell {
    override changeAction() {
        this.cellValueChange.emit(this.cellValue);
    }
}
